import { Route, Routes, useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { trackPageView } from "./utils/analytics";
import MemberLayout from "./layout/MemberLayout";
import Profile from "./modules/member/profile";
import Error from "./modules/error";
import Order from "./modules/member/order";
import Coupon from "./modules/member/coupon";
import AdminLayout from "./layout/AdminLayout";
import ECModule from "./modules/admin/applications/ec";
import MemberProvider from "./context/MemberProvider.tsx";
import Reservation from "./modules/reservation";
import ReservationProvider from "./context/ReservationProvider";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  const location = useLocation();

  useEffect(() => {
    // Track page view using the utility function
    trackPageView(location.pathname);
  }, [location]);

  return (
    <Sentry.ErrorBoundary fallback={<Error />}>
      <main className="bg-[#E7F2FF] w-full min-h-screen font-roboto text-title">
        <SentryRoutes>
          <Route
            path="/"
            element={
              <MemberProvider>
                <MemberLayout />
              </MemberProvider>
            }
          >
            <Route path="profile" element={<Profile />} />
            <Route path="order" element={<Order />} />
            <Route path="coupon" element={<Coupon />} />
          </Route>
          <Route path="/application" element={<AdminLayout />}>
            <Route index element={<ECModule />} />
          </Route>
          <Route path="/reservation" element={
            <ReservationProvider>
              <Reservation />
            </ReservationProvider>
          } />
          <Route path="*" element={<Error />} />
        </SentryRoutes>
      </main>
    </Sentry.ErrorBoundary>
  );
}

export default App;
